import Swal from 'sweetalert2';
import { confirmation } from './confirmation';
export interface IGetConfimrationBox {
    title: string;
    message: string;
    showCloseButton: boolean;
    confirmButtonColor?: string;
    showCancelButton?: boolean;
    subMessage?: string;
    iconClass?: string;
    isMessageBold?: boolean;
    isSubMessageBold?: boolean;
    showIcon?: boolean;
    showDenyButton?: boolean;
    denyButtonText?: string;
    messageAligned?: 'left' | 'right' | 'center';
}

/**
 * Wrapper to get confirmation popup.
 *
 * @param  {string}  key
 * @return {string}
 */
export function getConfirmationBox({
    title,
    message,
    showCloseButton,
    confirmButtonColor,
    showCancelButton = true,
    subMessage,
    iconClass = '',
    isMessageBold = false,
    isSubMessageBold = false,
    showIcon = true,
    showDenyButton = false,
    denyButtonText = '',
    messageAligned = 'center'
}: IGetConfimrationBox) {
    return Swal.fire({
        focusConfirm: false,
        allowEscapeKey: true,
        showCloseButton: showCloseButton,
        html: confirmation({
            title,
            message,
            subMessage,
            iconClass,
            isMessageBold,
            isSubMessageBold,
            showIcon,
            messageAligned
        }),
        showCancelButton: showCancelButton,
        confirmButtonColor: confirmButtonColor,
        showDenyButton: showDenyButton,
        denyButtonText
    });
}
